import * as React from 'react';
import { cn } from '@/lib/utils';

const DashboardSummaryWrapper = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-dashboard-summary-wrapper',
      // styles
      'mb-10 flex flex-wrap gap-3',
      className
    )}
    {...props}
  />
));
DashboardSummaryWrapper.displayName = 'DashboardSummaryWrapper';

const DashboardSummary = React.forwardRef(({ className, variant = 'default', ...props }, ref) => {
  const variants = {
    default: 'bg-white',
    bright: 'bg-bright [&_.c-dashboard-summary-body-count]:bg-white',
    icon: 'bg-white border border-solid border-neutral-lightest w-full flex-row items-start gap-4 items-stretch min-h-[100px]',
    'fast-access': 'cursor-pointer flex justify-between flex-row min-h-[100px] w-full bg-white shadow-dropshadow p-4 rounded-[10px]'
  };

  return (
    <div
      ref={ref}
      className={cn(
        'c-dashboard-summary',
        variant !== 'fast-access' && 'flex min-h-[134px] w-40 max-w-full grow flex-col justify-between break-words rounded-[10px] p-4 shadow-dropshadow',
        // styles
        variants[variant],
        className
      )}
      {...props}
    />
  );
});
DashboardSummary.displayName = 'DashboardSummary';

const DashboardSummaryHeader = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-dashboard-summary-header',
      // styles
      'mb-3',
      className
    )}
    {...props}
  />
));
DashboardSummaryHeader.displayName = 'DashboardSummaryHeader';

const DashboardSummaryHat = React.forwardRef(({ className, ...props }, ref) => (
  <p
    ref={ref}
    className={cn(
      'c-dashboard-summary-hat',
      // styles
      'mb-0 text-xs font-light text-neutral-dark',
      className
    )}
    {...props}
  />
));
DashboardSummaryHat.displayName = 'DashboardSummaryHat';

const DashboardSummaryTitle = React.forwardRef(({ className, ...props }, ref) => (
  <h3
    ref={ref}
    className={cn(
      'c-dashboard-summary-title',
      // styles
      'mb-0 text-base font-bold leading-tight text-primary-dark',
      className
    )}
    {...props}
  />
));
DashboardSummaryTitle.displayName = 'DashboardSummaryTitle';

const DashboardSummaryBody = React.forwardRef(({ className, isDashboard, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-dashboard-summary-body',
      // styles
      'flex grow flex-col gap-3 last:mb-0',
      isDashboard ? 'mb-3 gap-1 border-none p-0' : 'rounded-[10px] border border-solid border-neutral-lightest bg-white p-4',
      className
    )}
    {...props}
  />
));
DashboardSummaryBody.displayName = 'DashboardSummaryBody';

const DashboardSummaryCount = React.forwardRef(({ className, ...props }, ref) => (
  <p
    ref={ref}
    className={cn(
      'c-dashboard-summary-count',
      // styles
      'mb-0 text-2xl font-bold text-primary',
      className
    )}
    {...props}
  />
));
DashboardSummaryCount.displayName = 'DashboardSummaryCount';

const DashboardSummaryBodyCount = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-dashboard-summary-body-count',
      // styles
      'rounded bg-bright p-2 text-sm font-bold text-neutral-dark',
      className
    )}
    {...props}
  />
));
DashboardSummaryBodyCount.displayName = 'DashboardSummaryBodyCount';

const DashboardSummaryActionTitle = React.forwardRef(({ className, ...props }, ref) => (
  <h4
    ref={ref}
    className={cn(
      'c-dashboard-summary-action-title',
      // styles
      'mb-0 grow text-base font-bold text-primary-dark',
      className
    )}
    {...props}
  />
));
DashboardSummaryActionTitle.displayName = 'DashboardSummaryActionTitle';

const DashboardSummaryLink = React.forwardRef(({ className, ...props }, ref) => (
  <a
    ref={ref}
    className={cn(
      'c-dashboard-summary-link',
      // styles
      'cursor-pointer text-sm font-light text-primary underline',
      className
    )}
    {...props}
  />
));
DashboardSummaryLink.displayName = 'DashboardSummaryLink';

const DashboardSummaryContent = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-dashboard-summary-content',
      // styles
      'flex w-[120px] max-w-full grow flex-col justify-between',
      className
    )}
    {...props}
  />
));
DashboardSummaryContent.displayName = 'DashboardSummaryContent';

export {
  // exports
  DashboardSummaryWrapper,
  DashboardSummary,
  DashboardSummaryHeader,
  DashboardSummaryHat,
  DashboardSummaryTitle,
  DashboardSummaryBody,
  DashboardSummaryCount,
  DashboardSummaryBodyCount,
  DashboardSummaryActionTitle,
  DashboardSummaryLink,
  DashboardSummaryContent
};
